<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>
        {{$route.meta.title}}
      </h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>平台管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <el-row>
      <el-button type="primary"
                 :disabled="table.length === 3"
                 @click="$router.push({path: '/platform/home-module-form'})">添加模块
      </el-button>
      <br/><br/>
    </el-row>

    <layout-panel :show-header="false">
      <el-table ref="multipleTable"
                :data="table"
                stripe
                highlight-current-row
                style="width: 100%">
        <el-table-column prop="id"
                         label="模块id"></el-table-column>
        <el-table-column prop="type"
                         label="类型">
          <template slot-scope="scope">
            <span v-if="scope.row.type === 1">福利社</span>
            <span v-if="scope.row.type === 2">小零商城</span>
            <span v-if="scope.row.type === 3">小零招聘</span>
          </template>
        </el-table-column>
        <el-table-column prop="badge_start"
                         label="上线时间"></el-table-column>
        <el-table-column prop="badge_end"
                         label="下线时间"></el-table-column>
        <el-table-column prop="status"
                         label="模块状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 1">启用</span>
            <span v-if="scope.row.status === 0">不启用</span>
          </template>
        </el-table-column>
        <el-table-column prop="badge_type"
                         label="角标类型">
          <template slot-scope="scope">
            <span v-if="scope.row.badge_type === 1">上新角标</span>
          </template>
        </el-table-column>
        <el-table-column prop="badge_status"
                         label="角标状态">
          <template slot-scope="scope">
            <span v-if="scope.row.badge_status === 1">启用</span>
            <span v-if="scope.row.badge_status === 0">不启用</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="150">
          <template slot-scope="scope">
            <el-button type="text"
                       size="mini"
                       @click="goEditModule(scope.row)">编辑
            </el-button>
            <el-button type="text"
                       size="mini"
                       @click="operateLog(scope.row.id)">日志
            </el-button>
          </template>
        </el-table-column>
      </el-table>

    </layout-panel>

  </div>
</template>

<script>
import table from '@core/mixins/table'
import dateTimePicker from '@core/mixins/dateTimePicker'

export default {
  mixins: [table, dateTimePicker],
  data () {
    return {
      // 表格数据
      table: [],
    }
  },
  computed: Vuex.mapState({}),
  created () {
  },
  methods: {
    ...Vuex.mapActions({}),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('getHomeModuleTable', params)
    },
    setTableData ({data}) {
      let table = []
      data.forEach((row, index) => {
        table.push(row)
      })
      this.table = table
    },
    goEditModule (module) {
      this.$router.push({path: '/platform/home-module-form', query: {module: module}})
    },
    operateLog (id) {
      this.$router.push({path: '/platform/home-module-log-form', query: {id: id}})
    },

  },
}
</script>



// WEBPACK FOOTER //
// src/views/platform/pages/PlatformHomeModuleTable.vue